
export default {
  props: {
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: ''  
    }
  }   
}
